import type { FeatureManifest } from '../registry.js';

/**
 * SO-04.2 replay clip (P1): the round's best combo as a 6-second MP4 made on the device, opened
 * from the share composer's "Clip" option (SCR-08). No API: the clip is re-rendered from the
 * round's input log, so it works offline once its chunk is cached. The heavy parts (Pixi, the
 * view-pixi renderer, mediabunny) load only inside the view.
 */
export default {
  id: 'clip',
  flag: 'replayClip',
  provides: ['replayClip'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
